import React from 'react';
import {
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Bar
} from 'recharts';

import {
  formatForTimelineSingleChoice,
  removeYearFromArray
} from './utils.js'

import { answerColorDict } from '../../../resources/thematic-topics';

class TimelineSingleChoiceView extends React.PureComponent {
  render() {
    const { results, numberStates } = this.props;

    const formattedResults = formatForTimelineSingleChoice(results);
    const allowedKeys = removeYearFromArray(Object.keys(formattedResults[0]));

    return (
      <BarChart
        width={400}
        height={200}
        data={formattedResults}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        maxBarSize={80}
      >
        <XAxis dataKey="year" />
        <YAxis domain={[0, numberStates]} />
        <CartesianGrid strokeDasharray="3 3" />
        <Tooltip />
        <Legend />

        {/* For this type of chart we need to mention the Bars individually...: */}

        {allowedKeys.map(keyName => (
          <Bar
            key={keyName}
            dataKey={keyName}
            stackId="a"
            fill={answerColorDict[keyName]}
          />
        ))}
      </BarChart>
    );
  }
}

export default TimelineSingleChoiceView;



// WEBPACK FOOTER //
// ./src/components/Statistics/Views/TimelineSingleChoiceView.js